import localPolicySample from "../Data/policy.sample.json";
import { formatApiDate, getDayName } from "../services/apiClient";

export const LOCAL_POLICY_SAMPLE = localPolicySample;

export const SAMPLE_POLICY_JSON = JSON.stringify(localPolicySample, null, 2);

const isPrivacyPolicyShape = (value) =>
  Boolean(value?.title && Array.isArray(value?.data));

export const getLocalPolicyDisplay = () => ({
  ...localPolicySample,
  bannerName: localPolicySample.bannerName || localPolicySample.title,
  isLocalFallback: true,
});

const hasUsablePolicyData = (policyResponse) => {
  const apiData = policyResponse?.data;

  if (!apiData || typeof apiData !== "object") {
    return false;
  }

  if (typeof apiData.content === "string" && apiData.content.trim()) {
    return true;
  }

  return Boolean(apiData.name?.trim());
};

export const normalizePolicyDisplay = (policyResponse) => {
  const fallback = getLocalPolicyDisplay();

  if (!hasUsablePolicyData(policyResponse)) {
    return fallback;
  }

  const apiData = policyResponse.data;

  if (typeof apiData.content === "string") {
    try {
      const parsed = JSON.parse(apiData.content);

      if (isPrivacyPolicyShape(parsed)) {
        return {
          ...parsed,
          bannerName: apiData.name || parsed.bannerName || parsed.title,
          meta: {
            date: apiData.date,
            day: apiData.day,
            updatedAt: policyResponse.updatedAt,
          },
          isLocalFallback: false,
        };
      }
    } catch {
      // Plain text content stored in API.
    }

    if (apiData.content.trim()) {
      return {
        ...fallback,
        title: apiData.name || fallback.title,
        bannerName: apiData.name || fallback.bannerName,
        data: [{ id: "1", textDesc: apiData.content }],
        meta: {
          date: apiData.date,
          day: apiData.day,
          updatedAt: policyResponse.updatedAt,
        },
        isLocalFallback: false,
      };
    }
  }

  return {
    ...fallback,
    bannerName: apiData.name || fallback.bannerName,
    meta: {
      date: apiData.date,
      day: apiData.day,
      updatedAt: policyResponse?.updatedAt,
    },
    isLocalFallback: false,
  };
};

export const validatePolicyJson = (parsed) => {
  if (parsed?.date && parsed?.day && parsed?.name && parsed?.content) {
    return true;
  }

  return isPrivacyPolicyShape(parsed);
};

export const buildPolicyUploadPayload = (parsedFile) => {
  if (
    parsedFile?.date &&
    parsedFile?.day &&
    parsedFile?.name &&
    parsedFile?.content
  ) {
    return parsedFile;
  }

  if (isPrivacyPolicyShape(parsedFile)) {
    const now = new Date();

    return {
      date: parsedFile.date || formatApiDate(now),
      day: parsedFile.day || getDayName(now),
      name:
        parsedFile.bannerName ||
        parsedFile.policyName ||
        parsedFile.title ||
        "Privacy Policy",
      content: JSON.stringify(parsedFile),
    };
  }

  throw new Error(
    "Policy JSON must be Privacy Policy format (title, data[]) or API format (date, day, name, content).",
  );
};
